export const RECEIVE_DRUM_TYPES = 'dashboard/DrumTypesManagement/RECEIVE_DRUM_TYPES'
export const DELETE_DRUM_TYPE = 'dashboard/DrumTypesManagement/DELETE_DRUM_TYPE'
export const SET_IS_LOADING_DRUM_TYPES = 'dashboard/DrumTypesManagement/SET_IS_LOADING_DRUM_TYPES'
export const SET_PAGING = 'dashboard/DrumTypesManagement/SET_PAGING'
export const SET_QUERY_FILTER = 'dashboard/DrumTypesManagement/SET_QUERY_FILTER'

export const RECEIVE_DRUM_TYPE = 'dashboard/DrumTypesManagement/RECEIVE_DRUM_TYPE'
export const SET_IS_LOADING_DRUM_TYPE = 'dashboard/DrumTypesManagement/SET_IS_LOADING_DRUM_TYPE'
